/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { AppState } from "types/AppState";
import { CurrentUserLoadingState } from "reducers/CurrentUserReducer";
import { RecorderStatus } from "reducers/RecorderReducer";
import { EMPTY_SELECTION } from "reducers/SelectionReducer";
import { behanceApi, initialBehanceApiState } from "api/BehanceApi";
import { AudioPlayerState } from "AudioPlayer/AudioPlayer";
import { initialWaveformApiState, waveformApi } from "api/WaveformApi";

export const INITIAL_STATE: AppState = {
  currentUser: null,
  currentUserLoaded: CurrentUserLoadingState.NOT_LOADED,
  player: {
    currentTime: 0,
    duration: 0,
    playerState: AudioPlayerState.paused,
    isPlaying: false,
    initialAssetsLoaded: false,
    streaming: false,
  },
  recorder: {
    status: RecorderStatus.RECORDING_STOPPED,
    duration: 0,
  },
  deviceSettings: {
    inputDeviceId: "default",
  },
  project: null,
  clips: [],
  assets: {},
  assetUploads: {},
  participants: {},
  [behanceApi.reducerPath]: initialBehanceApiState,
  [waveformApi.reducerPath]: initialWaveformApiState,
  selection: EMPTY_SELECTION,
  pasteBuffer: {
    clips: [],
  },
  dragAndDrop: {
    dragActive: false,
    activeInsertDestinations: [],
  },
  musicCollection: {
    currentlyPreviewingTrackUrl: null,
  },
  toastMessages: [],
  serverTimeOffsetMs: null,
  recordingSessions: {},
  inviteGuestsPopupOpen: false,
};
